export enum SimTypeSupport {
  Unknown = 'Unknown',
  Esim = 'Esim',
  Psim = 'Psim',
  Both = 'Both',
}
